export enum QuoteEventRateType {
  CARRIER = 'CARRIER',
  CUSTOMER = 'CUSTOMER',
}

// NOTE: Values are persisted in quote_events.metadata; do not rename.
export enum QuoteAutoReplySentSource {
  AUTOMATION = 'automation',
  USER_SENT_DRAFT = 'user_sent_draft',
}
